import { useEffect, useState } from 'react';
import '../styles/Settings.css'; // Reuse existing styles
import RelativeSvgLoader from '../common/components/RelativeSvgLoader';
import YesNoPopup from '../common/components/YesNoPopup';
import Post from '../services/postService';
import AuthData from '../common/AuthData';
import Fetch  from '../services/fetchService';
import Error from  '../common/components/ErrorMessage'
import Success from  '../common/components/SuccessMessage'
import { SETTINGS_API } from '../common/ResourcePaths'; // Import the constants
import { FaExclamationCircle } from 'react-icons/fa'; // Import exclamation icon


function SocialMedia() {
    const [telephone, setTelephone] = useState('');
    const [whatsapp, setWhatsapp] = useState('');
    const [facebookRestUrl, setFacebookRestUrl] = useState('');
    const [facebookName, setFacebookName] = useState('');
    const [instagramRestUrl, setInstagramRestUrl] = useState('');
    const [disabled, setDisabled] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);
    const [showPopup, setShowPopup] = useState(false); // State for popup visibility
    const [loader, setLoader] = useState(false); // State for loader visibility
    const [modified, setModified] = useState(false); // State for modified data
    const [error, setError] = useState(''); // State to manage error messages
    const [success, setSuccess] = useState(false); // State to manage success messages
    const [successTimer, setSuccessTimer] = useState(10); // Timer for success message

    const phoneRegex = /^[\d+()\s-]*$/;

    const updateData = (contactInfo) => 
    {
        setTelephone(contactInfo.phone?.link || '');
        setWhatsapp(contactInfo.whatsApp?.link || '');
        setFacebookRestUrl(contactInfo.facebook?.link || '');
        setInstagramRestUrl(contactInfo.instagram?.link || '');
        setFacebookName(contactInfo.facebook?.name || '');
        setDisabled(contactInfo.disabled || false);
    }

    useEffect(() => {
        const getSettings = async () => {
            try {
                setLoader(true);
                const authData = AuthData.getAuthData();
                const url = `${authData.appFunctionUrl}${SETTINGS_API}/contactInfo?code=${authData.azureFunctionKey}`; // Use the constant here
                const response = await Fetch(url, authData.clientId);
                updateData(response);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoader(false);
            }
        };

        getSettings();
       
    },[]);


    const saveHandler = async (e) => {
        e.preventDefault(); // Prevent default form submission

        // Validation: Check if Facebook profile is filled but display name is empty
        if (facebookRestUrl && !facebookName) {
            setError('Please fill in the Facebook display name if the Facebook profile is provided.');
            return;
        }

        setError(''); // Clear any previous errors
        setLoader(true);
        const data = {
            phone: {
                name: '',
                link: telephone
            },
            whatsapp: {
                name: '',
                link: whatsapp
            },
            facebook: {
                name: facebookName,
                link: facebookRestUrl
            },
            instagram: {
                name: '',
                link: instagramRestUrl
            },
            disabled: disabled
        };

        const authData = AuthData.getAuthData();

        const url = `${authData.appFunctionUrl}${SETTINGS_API}/contact?code=${authData.azureFunctionKey}`; // Use the constant here

        try {
            const response = await Post(url,authData.clientId, data); // Assuming `save` is the method in postService
            updateData(response);
            setSuccess(true); // Show success message
            setSuccessTimer(10); // Reset timer to 10 seconds

            // Start countdown timer
            const timerInterval = setInterval(() => {
                setSuccessTimer((prev) => {
                    if (prev <= 1) {
                        clearInterval(timerInterval); // Clear timer when it reaches 0
                        setSuccess(false); // Hide success message
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        } catch (error) {
            console.error('Error saving data:', error);
            setError("An error occurred while saving data.");
        }finally{
            setLoader(false);
            setModified(false); // Reset modified state after saving
        }
    };

    const handleWhatsAppChange = (e) => {
        const value = e.target.value;
        if (phoneRegex.test(value)) {
            setWhatsapp(value);
        }
        setModified(true);
    };

    const handleFacebookChange = (e) => {
        const value = e.target.value;
        setFacebookRestUrl(value);
        setModified(true);
    }

    const handleFacebookNameChange = (e) => {
        const value = e.target.value;
        setFacebookName(value);
        setModified(true);
        setError(''); // Clear error when Facebook name is changed
    };

    const handleTelephoneChange = (e) => {
        const value = e.target.value;
        if (phoneRegex.test(value)) {
            setTelephone(value);
        }
        setModified(true);
    };

    const handleInstagramChange = (e) => {
        const value = e.target.value;
        setInstagramRestUrl(value);
        setModified(true);
    }

    const handleSocialMediaDisabledChange = (e) => {
        setDisabled(e.target.checked);
        setModified(true);
    };

    const reset = () => {
        setTelephone('');
        setWhatsapp('');
        setFacebookRestUrl('');
        setInstagramRestUrl('');
        setFacebookName('');
        setDisabled(false);
        setModified(true);
    };

    const handleYes = () => {
        setShowPopup(false);
        reset(); // Perform action on "Yes"
    };

    const handleNo = () => {
        setShowPopup(false); // Close popup on "No"
    };

    return (
        <div className="container" style={{ position: 'relative' }}>
            {loader && <RelativeSvgLoader />}
            <div className="form-wrapper" style={{ opacity: loader ? 0.3 : 1 }}>
                {error && <Error message={error}/>} {/* Render error message */}
                {success && <Success message={`Data saved successfully! (${successTimer}s)`} />} {/* Render success message with timer */}
                <div style={{display: 'flex', justifyContent: 'flex-end', marginBottom: '15px'}}>
                    <label style={{display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.9rem', fontWeight: 'bold'}}>
                        <input
                            type="checkbox"
                            checked={disabled}
                            onChange={handleSocialMediaDisabledChange}
                        />
                        Disable
                        <div style={{position: 'relative', display: 'inline-block'}}>
                            <FaExclamationCircle
                                style={{
                                    color: '#28a745',
                                    fontSize: '14px',
                                    marginLeft: '4px',
                                    cursor: 'help'
                                }}
                                onMouseEnter={() => setShowTooltip(true)}
                                onMouseLeave={() => setShowTooltip(false)}
                            />
                            {showTooltip && (
                                <div style={{
                                    position: 'absolute',
                                    bottom: '20px',
                                    right: '0',
                                    backgroundColor: '#28a745',
                                    color: 'white',
                                    padding: '8px 12px',
                                    borderRadius: '4px',
                                    fontSize: '12px',
                                    whiteSpace: 'nowrap',
                                    zIndex: 1000,
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
                                }}>
                                    When checked, hides all social media contacts from customers
                                    <div style={{
                                        position: 'absolute',
                                        top: '100%',
                                        right: '10px',
                                        width: 0,
                                        height: 0,
                                        borderLeft: '5px solid transparent',
                                        borderRight: '5px solid transparent',
                                        borderTop: '5px solid #28a745'
                                    }}></div>
                                </div>
                            )}
                        </div>
                    </label>
                </div>
                <form onSubmit={(e) => saveHandler(e)}>
                    <div className="form-grid">
                        <label htmlFor="telephone" className="form-label">Telephone Number (Primary Contact):</label>
                        <input
                            type="text"
                            id="telephone"
                            name="telephone"
                            value={telephone}
                            onChange={handleTelephoneChange}
                            readOnly={disabled}
                            className="input-field"
                        />
                        <label htmlFor="whatsapp" className="form-label">WhatsApp Contact Number:</label>
                        <input 
                            type="text" 
                            id="whatsapp" 
                            name="whatsapp" 
                            value={whatsapp}
                            onChange={handleWhatsAppChange}
                            readOnly={disabled}
                            className="input-field"
                        />
                        <label className="form-label">Facebook Profile:</label>
                        <div className="facebook-profile-container">
                            <input
                                type="text"
                                value="https://facebook.com/"
                                disabled
                                className="input-field-facebook"
                            />
                            <input
                                type="text"
                                value={facebookRestUrl}
                                onChange={(e) => handleFacebookChange(e)}
                                readOnly={disabled}
                                className="input-field"
                            />
                        </div>
                        <label htmlFor="fbProfileName" className="form-label">Facebook display name:</label>
                        <input
                            type="text"
                            id="fbProfileName"
                            name="fbProfileName"
                            value={facebookName}
                            onChange={handleFacebookNameChange}
                            readOnly={disabled}
                            className="input-field"
                        />
                        <label className="form-label">Instagram Profile:</label>
                        <div className="facebook-profile-container">
                            <input
                                type="text"
                                value="@"
                                disabled
                                className="input-field-instagram-symbol"
                            />
                            <input
                                type="text"
                                value={instagramRestUrl}
                                onChange={(e) => handleInstagramChange(e)}
                                readOnly={disabled}
                                className="input-field"
                            />
                        </div>
                    </div>
                    <div className='form-footer'>
                            <button type="submit" disabled={!modified} className="submit-button">Save</button>
                            <button type="button" 
                                className='clear-data-button' 
                                style={{ marginLeft: '10px' }} onClick={() => setShowPopup(true)}>Reset</button>
                    </div>
                </form>
            </div>

            {showPopup && (
               <YesNoPopup 
                handleYes={handleYes} 
                handleNo={handleNo}/>
            )}
        </div>
    );
}

export default SocialMedia;